import {
    useTranslate,
    IResourceComponentsProps,
    // useNavigation,
    // useShow,
} from "@pankod/refine-core";

import {
    List,
    Table,
    useTable,
    DateField,
    // Dropdown,
    BooleanField,
    FilterDropdown,
    Radio,
    getDefaultSortOrder,
    // Menu,
    // Icons,
    Space,
    Select,
    EditButton,
    // Avatar,
    // useModal,
    useSelect,
} from "@pankod/refine-antd";


import { IStore, IOrganization, IRoom } from "interfaces";
import { ConnectionStatus } from "components/connectionStatus";
// import { title } from "process";
// import { StoreProducts } from "components/store";

// const { FormOutlined } = Icons;

export const StoreList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter } = useTable<IStore>({
    initialSorter: [{
      field: "title",
      order: "asc",
    }],
    metaData: {
      select: "*, organizations!stores_organization_id_fkey(id, title), rooms!fk_stores_room_id(id, title)",
      // select: "*, organizations:organization_id(title), rooms:room_id(title)",
    },
  });
//   const { edit } = useNavigation();
//   const { show } = useModal();
  // const { modalProps, show } = useModal();

  const t = useTranslate();

//   const { setShowId } = useShow<IStore>();
  // const { queryResult, setShowId } = useShow<IStore>();

  // const { data: showQueryResult } = queryResult;
  // const record = showQueryResult?.data;

  const renderDeleteFile = (value: number) => {
    // console.log("renderDeleteFile", value);
    if (value > 0) {
      return (
        <Space>{t("table.deleteFileHelp", {day: value})}</Space>
      );
    }
    return (
      <Space />
    );
  };

  const { selectProps } = useSelect<IOrganization>({
    resource: "organizations",
  });
  const { selectProps: roomSelectProps } = useSelect<IRoom>({
    resource: "rooms",
  });

//   const moreMenu = (id: number) => (
//     <Menu mode="vertical">
//         <Menu.Item
//             key="1"
//             style={{
//                 fontSize: 15,
//                 fontWeight: 500,
//             }}
//             icon={
//                 <FormOutlined
//                     style={{ color: "green", fontSize: "15px" }}
//                 />
//             }
//             onClick={() => edit("stores", id)}
//         >
//         {t("buttons.edit")}
//     </Menu.Item>
//     <Menu.Item
//         key="2"
//         style={{
//             fontSize: 15,
//             fontWeight: 500,
//         }}
//         icon={
//             <FormOutlined
//                 style={{ color: "green", fontSize: "15px" }}
//             />
//         }
//         onClick={() => {
//                     show();
//                     setShowId(id);
//                 }}
//             >
//                 {t("stores.buttons.edit")}
//             </Menu.Item>
//     </Menu>
//   );

  return (
    <>
      <List>
        <Table {...tableProps} rowKey="id">
          {/* <Table.Column
              key="image"
              align="center"
              render={() => (
                  <Avatar
                      src="/images/default-store-img.png"
                      alt="Default Store Image"
                      size={64}
                  />
              )}
          /> */}
          <Table.Column
            dataIndex="id"
            align="center"
            title="ID"
          />
          <Table.Column
            dataIndex="title"
            title={t("stores.fields.title")}
            sorter
          />
          <Table.Column
            key="organization_id"
            dataIndex={["organizations", "title"]}
            title={t("stores.fields.organizations")}
            defaultSortOrder={getDefaultSortOrder(
              "organizations.title",
              sorter,
            )}
            filterDropdown={(props) => (
              <FilterDropdown {...props}>
                <Select
                  style={{ minWidth: 200 }}
                  mode="multiple"
                  placeholder={t("select.organization")}
                  {...selectProps}
                />
              </FilterDropdown>
            )}
          />
          <Table.Column
            key="room_id"
            dataIndex={["rooms", "title"]}
            title={t("stores.fields.room")}
            // defaultSortOrder={getDefaultSortOrder(
            //   "rooms.title",
            //   sorter,
            // )}
            filterDropdown={(props) => (
              <FilterDropdown {...props}>
                <Select
                  style={{ minWidth: 200 }}
                  mode="multiple"
                  placeholder={t("select.room")}
                  {...roomSelectProps}
                />
              </FilterDropdown>
            )}
          />
          <Table.Column
            dataIndex="status"
            title={t("stores.fields.connection")}
            filterDropdown={(props) => (
              <FilterDropdown {...props}>
                  <Radio.Group>
                    <Radio value="connected">{t("enum.connectionStatuses.connected")}</Radio>
                    <Radio value="Disconnected">{t("enum.connectionStatuses.Disconnected")}</Radio>
                    <Radio value="Overdue">{t("enum.connectionStatuses.Overdue")}</Radio>
                  </Radio.Group>
              </FilterDropdown>
            )}
            render={(value) => {
              return <ConnectionStatus status={value} />;
            }}
            // defaultSortOrder={getDefaultSortOrder(
            //     "status.text",
            //     sorter,
            // )}
            // sorter
          />
            {/* <Table.Column
              dataIndex="gsm"
              title={t("stores.fields.gsm")}
            />
            <Table.Column
              dataIndex={["address", "text"]}
              title={t("stores.fields.address")}
            /> */}
          <Table.Column
            dataIndex="is_active"
            title={t("stores.fields.isActive")}
            align="center"
            filterDropdown={(props) => (
              <FilterDropdown {...props}>
                  <Radio.Group>
                    <Radio value="true">{t("status.enable")}</Radio>
                    <Radio value="false">{t("status.disable")}</Radio>
                  </Radio.Group>
              </FilterDropdown>
            )}
            render={(value) => <BooleanField value={value} />}
          />
          <Table.Column
            dataIndex="delete_file"
            title={t("table.deleteFile")}
            render={(value) => renderDeleteFile(value)}
          />
          <Table.Column
            dataIndex="updated_at"
            title={t("stores.fields.updatedAt")}
            render={(value) => (
              <DateField value={value} format="LLL" />
            )}
            sorter
          />
          <Table.Column<IStore>
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton hideText size="small" recordItemId={record.id} />
              </Space>
            )}
            // fixed="right"
            // title={t("table.actions")}
            // dataIndex="actions"
            // key="actions"
            // align="center"
            // render={(_, record) => (
            //     <Dropdown
            //         overlay={moreMenu(record.id)}
            //         trigger={["click"]}
            //     >
            //         <Icons.MoreOutlined
            //             style={{
            //                 fontSize: 24,
            //             }}
            //         />
            //     </Dropdown>
            // )}
          />
        </Table>
      </List>
      {/* {record && (
        <StoreProducts modalProps={modalProps} record={record} />
      )} */}
    </>
  );
};
